import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CancelIconButton, SecondaryButton } from "../../../../components/Buttons";

const SearchDialog = ({
  searchText,
  matchCount,
  currentIndex,
  matches = [],
  onSearch,
  onPrevious,
  onNext,
  onSelectMatch,
  onClose,
  panelView = false,
}) => {
  const [localSearchText, setLocalSearchText] = useState(searchText);
  const inputRef = useRef(null);

  console.log('SearchDialog rendered, searchText:', searchText, 'matchCount:', matchCount);

  // Sync local state with prop when it changes externally
  useEffect(() => {
    console.log('SearchDialog useEffect - syncing searchText:', searchText);
    setLocalSearchText(searchText);
  }, [searchText]);

  // Focus input when dialog opens
  useEffect(() => {
    console.log('SearchDialog useEffect - focusing input');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSearchChange = (e) => {
    console.log('handleSearchChange called, value:', e.target.value);
    const value = e.target.value;
    setLocalSearchText(value);
    onSearch(value); // Call onSearch with the new value
    // // Only trigger search if at least 3 characters
    // if (value.length >= 3) {
    //   onSearch(value);
    // } else if (value.length === 0) {
    //   onSearch('');
    // }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        onPrevious();
      } else {
        onNext();
      }
    }
  };

  if (panelView) {
    return (
      <div
        className="pad-big-top"
        style={{
          // position: 'absolute',
          // top: '0px',
          // left: '0px',
          // zIndex: 9999,
          // width: '100%',
          // height: '100%',
        }}
      >
        <div className="w3-border w3-white pad">
          <div className="pad-" style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <h4 className="no-margin">Suche</h4>
              <CancelIconButton size="small" className="w3-right no-pad" onClick={onClose} />
          </div>
          <div className="margin-top w3-row w3-align-items-center">
            <div className="w3-col" style={{ flex: 1 }}>
              <input
                ref={inputRef}
                type="text"
                className="w3-input w3-border"
                placeholder="Text suchen (mindestens 3 Zeichen)..."
                value={localSearchText}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
              />
            </div>
            {/* <div className="w3-col w3-right-align" style={{ minWidth: '120px', paddingLeft: '8px' }}>
              <span className="w3-text-grey" style={{ fontSize: '12px' }}>
                {matchCount > 0 ? `${currentIndex + 1} von ${matchCount}` : (localSearchText ? 'Keine Treffer' : '')}
              </span>
            </div> */}
            <div className="w3-col w3-cell-row" style={{ minWidth: '120px' }}>
              <div className="w3-cell w3-left-align pad-rht">
                <span className="w3-text-red" style={{ fontSize: '12px' }}>
                  {localSearchText.length < 3 && 'Bitte mindestens 3 Zeichen eingeben'}
                </span>
              </div>
              <div className="w3-cell w3-right-align pad-lft">
                <span className="w3-text-grey" style={{ fontSize: '12px' }}>
                  {matchCount > 0 ? `${currentIndex + 1} von ${matchCount}` : (localSearchText ? 'Keine Treffer' : '')}
                </span>
              </div>
            </div>
          </div>
          <div className="margin-top" style={{ /* maxHeight: "220px", overflowY: "auto",  */border: "1px solid #ddd" }}>
            {matchCount === 0 ? (
              <div className="pad w3-text-grey" style={{ fontSize: "12px" }}>
                Keine Treffer
              </div>
            ) : (
              matches.map((match, index) => {
                // Highlight the matched text within the context
                const matchText = match.matchText || match.text;
                const contextText = match.text;
                const matchIndex = contextText.toLowerCase().indexOf(matchText.toLowerCase());
                
                let textElement;
                if (matchIndex >= 0) {
                  const before = contextText.slice(0, matchIndex);
                  const after = contextText.slice(matchIndex + matchText.length);
                  textElement = (
                    <>
                      {before && <span className="w3-text-grey">{before}</span>}
                      <span style={{ fontWeight: 600, color: "#333" }}>{matchText}</span>
                      {after && <span className="w3-text-grey">{after}</span>}
                    </>
                  );
                } else {
                  textElement = <span>{contextText}</span>;
                }
                
                return (
                  <button
                    key={match.id !== undefined ? match.id : index}
                    type="button"
                    onClick={() => onSelectMatch(index)}
                    className="w3-button"
                    style={{
                      width: "100%",
                      textAlign: "left",
                      borderBottom: "1px solid #eee",
                      backgroundColor: currentIndex === index ? "#f0f0f0" : "transparent",
                      padding: "8px 12px",
                      lineHeight: "1.4",
                    }}
                  >
                    <span style={{ fontWeight: 600, marginRight: "8px", color: "#666" }}>{index + 1}.</span>
                    {textElement}
                  </button>
                );
              })
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="w3-border w3-card w3-light-grey pad search-dialog"
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        zIndex: 9999,
        minWidth: '300px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
      }}
    >
      <div className="w3-row w3-align-items-center">
        <div className="w3-col" style={{ flex: 1 }}>
          <input
            ref={inputRef}
            type="text"
            className="w3-input w3-border"
            placeholder="Text suchen..."
            value={localSearchText}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        {/* <div className="w3-col w3-right-align" style={{ minWidth: '120px', paddingLeft: '8px' }}>
          <span className="w3-text-grey" style={{ fontSize: '12px' }}>
            {matchCount > 0 ? `${currentIndex + 1} von ${matchCount}` : (localSearchText ? 'Keine Treffer' : '')}
          </span>
        </div> */}
        <div className="w3-col w3-cell-row" style={{ minWidth: '120px' }}>
          <div className="w3-cell w3-left-align pad-rht">
            <span className="w3-text-red" style={{ fontSize: '12px' }}>
              {localSearchText.length < 3 && 'Bitte mindestens 3 Zeichen eingeben'}
            </span>
          </div>
          <div className="w3-cell w3-right-align pad-lft">
            <span className="w3-text-grey" style={{ fontSize: '12px' }}>
              {matchCount > 0 ? `${currentIndex + 1} von ${matchCount}` : (localSearchText ? 'Keine Treffer' : '')}
            </span>
          </div>
        </div>
      </div>
      <div className="margin-top" style={{ display: "flex", alignItems: "center" }}>
        <SecondaryButton size="small" onClick={onPrevious} disabled={matchCount === 0}>
          {/* &lt;  */}Zurück
        </SecondaryButton>
        <SecondaryButton size="small" className="margin-lft" onClick={onNext} disabled={matchCount === 0}>
          Weiter{/* &gt; */}
        </SecondaryButton>
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", minWidth: "100px"}}>
          {/* <SecondaryButton size="small" className="w3-right" onClick={onClose}>
            ✕
          </SecondaryButton> */}
          <CancelIconButton size="small" className="w3-right" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

SearchDialog.propTypes = {
  searchText: PropTypes.string,
  matchCount: PropTypes.number,
  currentIndex: PropTypes.number,
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
    })
  ),
  onSearch: PropTypes.func,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  onSelectMatch: PropTypes.func,
  onClose: PropTypes.func,
  panelView: PropTypes.bool,
};

export default SearchDialog;